"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AccordionVariantCardWrapper = exports.AccordionVariantButton = exports.AccordionVariantTitleWrap = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Button = _interopRequireDefault(require("../Button"));

var AccordionVariantTitleWrap = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      mediaQueries = _ref$theme.mediaQueries;
  return _defineProperty({
    marginBottom: space.large
  }, mediaQueries.medium, {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  });
});
exports.AccordionVariantTitleWrap = AccordionVariantTitleWrap;
var AccordionVariantButton = (0, _styled.default)(_Button.default)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      space = _ref3$theme.space,
      mediaQueries = _ref3$theme.mediaQueries;
  return _defineProperty({
    marginTop: space.large,
    display: 'inline-block',
    width: 'auto'
  }, mediaQueries.medium, {
    marginLeft: space.large,
    marginTop: 0
  });
});
exports.AccordionVariantButton = AccordionVariantButton;
var AccordionVariantCardWrapper = (0, _styled.default)('div')(function () {
  return {
    overflow: 'hidden'
  };
});
exports.AccordionVariantCardWrapper = AccordionVariantCardWrapper;